export default "__VITE_ASSET__De1cih5c__"